"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var unleash_1 = require("./unleash");
var variant_1 = require("./variant");
var index_1 = require("./strategy/index");
exports.Strategy = index_1.Strategy;
var unleash_2 = require("./unleash");
exports.Unleash = unleash_2.Unleash;
var instance;
function initialize(options) {
    instance = new unleash_1.Unleash(options);
    instance.on('error', function () { });
    return instance;
}
exports.initialize = initialize;
function isEnabled(name, context, fallbackValue) {
    if (context === void 0) { context = {}; }
    return !!instance && instance.isEnabled(name, context, fallbackValue);
}
exports.isEnabled = isEnabled;
function destroy() {
    return instance && instance.destroy();
}
exports.destroy = destroy;
function getFeatureToggleDefinition(toggleName) {
    return instance && instance.getFeatureToggleDefinition(toggleName);
}
exports.getFeatureToggleDefinition = getFeatureToggleDefinition;
function getFeatureToggleDefinitions() {
    return instance && instance.getFeatureToggleDefinitions();
}
exports.getFeatureToggleDefinitions = getFeatureToggleDefinitions;
function getVariant(name, context, fallbackVariant) {
    if (context === void 0) { context = {}; }
    if (!fallbackVariant) {
        fallbackVariant = variant_1.getDefaultVariant();
    }
    return instance ? instance.getVariant(name, context, fallbackVariant) : fallbackVariant;
}
exports.getVariant = getVariant;
function count(toggleName, enabled) {
    return instance && instance.count(toggleName, enabled);
}
exports.count = count;
function countVariant(toggleName, variantName) {
    return instance && instance.countVariant(toggleName, variantName);
}
exports.countVariant = countVariant;
//# sourceMappingURL=index.js.map